import StatsWidgets from '@rio-cloud/rio-uikit/StatsWidgets';
import StatsWidget from '@rio-cloud/rio-uikit/StatsWidget';
import StatusBar from '@rio-cloud/rio-uikit/StatusBar';
import styles from './FinancialHealthCard.module.css'

interface FinancialHealthCardProps {
    score: number,
    maxScore: number,
    level: number,
    nextLevelScore: number,
    lastScore: number,
}

export function FinancialHealthCard({ score, maxScore, level, nextLevelScore, lastScore }: FinancialHealthCardProps) {

    const calculatePercentage = (partialValue: number, totalValue: number): number => {
        if (totalValue === 0) {
            console.warn("Attention: The Financial Health MaxScore Value is zero. Returning 0 to prevent division by zero.");
            return 0;
        }
        const percentage = (partialValue / totalValue) * 100;
        return percentage;
    }

    const setStatusIcon = () => {
        if (score > lastScore) {
            return 'rioglyph-angle-double-up';
        } else {
            return 'rioglyph-angle-double-down';
        }
    }

    const setIconColor = () => {
        if (score === lastScore) {
            return 'text-color-status-resting';
        } else if (score > lastScore) {
            return 'text-color-success';
        } else {
            return '';
        }
    }

    const setMessage = () => {
        if (score === lastScore) {
            return 'permaneceu a mesma da anterior';
        } else if (score > lastScore) {
            return 'superou a anterior!';
        } else {
            return 'ficou abaixo da anterior';
        }
    }

    const setStatusIconColor = () => {
        if (level === 1) {
            return 'text-color-highlight-darkest';
        } else if (level === 2) {
            return 'text-color-highlight-darker';
        } else if (level === 3) {
            return 'text-color-highlight';
        } else {
            return 'text-color-success';
        }
    }

    const setStatusBarBackground = () => {
        if (level === 1) {
            return 'bg-highlight-darkest';
        } else if (level === 2) {
            return 'bg-highlight-darker';
        } else if (level === 3) {
            return 'bg-highlight';
        } else {
            return 'bg-success';
        }
    }

    const setAuxStatusIcon = () => {
        if (score === maxScore) {
            return 'rioglyph-ok-sign'
        } else {
            return 'rioglyph-ongoing'
        }
    }


    return (
        <StatsWidgets>
            <StatsWidget className='shadow-default'>
                <StatsWidget.Header>Saúde Financeira</StatsWidget.Header>
                <StatsWidget.Body className='padding-20'>
                    <div className={styles['score-container']}>
                        <div className={styles["text-area"]}>
                            <p className={styles["main-text"]}>A pontuação deste mês</p>
                            <p className={styles["sub-text"]}>{setMessage()}</p>
                        </div>
                        <div className={styles["score-number"]}>
                            <span className={styles["current-score"]}>{score}</span>
                            <span className={styles["total-score"]}>/ {maxScore}</span>
                        </div>
                        {score != lastScore ? (
                            <div>
                                <span className={`rioglyph ${setStatusIcon()} ${setIconColor()} ${styles["status-icon"]}`}></span>
                            </div>
                        ) : (
                            null
                        )}
                    </div>
                    <div className={styles["progress-bar-container"]}>
                        <div className={styles["progess-bar-status-icon"]}>
                            <span className={`rioglyph ${setAuxStatusIcon()} ${setStatusIconColor()}`}></span>
                        </div>
                        <div className="display-flex flex-1-0 flex-order-1 flex-column margin-bottom-10">
                            <div>
                                <div className={styles["progress-bar-icons-container"]} style={{ gridTemplateColumns: `${calculatePercentage(score, maxScore)}% ${calculatePercentage(nextLevelScore - score, maxScore)}%` }}>
                                    {score > 0 ? (
                                        <div className={styles["progress-bar-icons"]}>
                                            <span className={`rioglyph rioglyph-delivery ${setStatusIconColor()}`}></span>
                                        </div>
                                    ) : (
                                        null
                                    )}

                                    {score < nextLevelScore ? (
                                        <div className={styles["progress-bar-icons"]}>
                                            <span className='rioglyph rioglyph-flag text-color-gray'></span>
                                        </div>
                                    ) : (
                                        null
                                    )}

                                </div>
                                <StatusBar
                                    progress={[
                                        { percentage: calculatePercentage(score, maxScore), color: setStatusBarBackground() },
                                        { percentage: calculatePercentage(nextLevelScore - score, maxScore), color: 'bg-gray', tooltip: <span>Faça +{nextLevelScore - score} pontos para ter uma Saúde Financeira Épica</span> },
                                        { percentage: calculatePercentage((maxScore - score - nextLevelScore), maxScore), color: 'bg-light' }
                                    ]}
                                    size='small'
                                    useProgressDivider={true}
                                />
                            </div>
                        </div>
                    </div>
                </StatsWidget.Body>
            </StatsWidget>
        </StatsWidgets>
    );
}